// extracted by mini-css-extract-plugin
export default {"caseStudies":"CaseStudiosBlock_caseStudies__ECcpn","mobileName":"CaseStudiosBlock_mobileName__vaVwr"};